import type { PurchaseInfo } from '../../ReplicantAPI';

export function getPurchaseHistory(
    metainfo: { purchaseHistory?: PurchaseInfo[] },
    chatbotMetainfo: { purchaseHistory?: PurchaseInfo[] },
): PurchaseInfo[] {
    const result: PurchaseInfo[] = [];

    if (metainfo.purchaseHistory) {
        for (const info of metainfo.purchaseHistory) {
            const item = { ...info };

            // Convert second-level timestamps to milliseconds:
            const isMillisecondTimestamp = info.purchase_time.toString().length === 13;
            if (isMillisecondTimestamp) {
                item.issued_at = Number(info.issued_at);
                item.purchase_time = Number(info.purchase_time);
            } else {
                item.issued_at = Number(info.issued_at) * 1000;
                item.purchase_time = Number(info.purchase_time) * 1000;
            }

            result.push(item);
        }
    }

    if (chatbotMetainfo?.purchaseHistory) {
        result.push(...chatbotMetainfo.purchaseHistory);
    }

    return result;
}
